/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import T from 'prop-types';
export var Icon = function Icon(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      stroke: 'none',
      strokeWidth: 1,
      fill: 'none',
      fillRule: 'evenodd',
      overflow: 'visible'
    }
  }, props));
};
export var SearchIcon = function SearchIcon(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26093 2.94357C10.9411 2.94357 12.5529 3.61525 13.7417 4.81147C14.9297 6.00674 15.5973 7.6284 15.5973 9.31991C15.5973 11.0114 14.9297 12.6331 13.7417 13.8283C12.5529 15.0245 10.9411 15.6962 9.26093 15.6962C7.57981 15.6962 5.96801 15.0246 4.77916 13.8283C3.59122 12.6331 2.9227 11.0114 2.9227 9.31991C2.9227 7.6284 3.59122 6.00669 4.77916 4.81147C5.96803 3.61527 7.57978 2.94357 9.26093 2.94357V2.94357ZM9.26093 9.61436e-05C6.38901 0.00103947 3.68031 1.34253 1.92692 3.63017C0.174537 5.91883 -0.425529 8.89524 0.303935 11.6895C1.0334 14.4837 3.00975 16.7799 5.65388 17.9063C8.69934 19.1846 12.1908 18.7365 14.82 16.7299C17.449 14.7233 18.8189 11.4622 18.4166 8.16587C18.0143 4.87052 15.9011 2.03959 12.8669 0.733043C11.7259 0.247205 10.4995 -0.00280193 9.261 2.3687e-05L9.26093 9.61436e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0557 16.0764L16.125 13.9944L24 21.918L21.9307 24L14.0557 16.0764Z",
    fill: "white"
  }));
};
SearchIcon.propTypes = {
  className: T.string
};
export var RadioButtonOffIcon = function RadioButtonOffIcon(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.83181 0 0 5.83152 0 13C0 20.1685 5.83152 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83152 20.1685 0 13 0ZM13 23.4009C7.26435 23.4009 2.59885 18.7345 2.59885 12.9997C2.59885 7.26406 7.26406 2.59856 13 2.59856C18.7359 2.59856 23.4012 7.26493 23.4012 12.9997C23.4012 18.7345 18.7359 23.4009 13 23.4009Z",
    fill: "white",
    fillOpacity: "0.5",
    transform: "translate(0, 4)"
  }));
};
RadioButtonOffIcon.propTypes = {
  className: T.string
};
export var RadioButtonOnIcon = function RadioButtonOnIcon(_ref4) {
  var className = _ref4.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13C4 8.03718 8.03718 4 13 4C17.9628 4 22 8.03718 22 13C22 17.9628 17.9628 22 13 22C8.03718 22 4 17.9628 4 13Z",
    fill: "white",
    transform: "translate(0, 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.83152 5.83181 0 13 0C20.1685 0 26 5.83152 26 13C26 20.1685 20.1685 26 13 26C5.83152 26 0 20.1685 0 13ZM2.59885 12.9997C2.59885 18.7345 7.26435 23.4009 13 23.4009C18.7359 23.4009 23.4012 18.7345 23.4012 12.9997C23.4012 7.26493 18.7359 2.59856 13 2.59856C7.26406 2.59856 2.59885 7.26406 2.59885 12.9997Z",
    fill: "white",
    transform: "translate(0, 4)"
  }));
};
RadioButtonOnIcon.propTypes = {
  className: T.string
};
export var ArrowUpIcon = function ArrowUpIcon(_ref5) {
  var className = _ref5.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 22 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.496205 10.568L2.47962 12.5174L10.7627 4.0603L19.2199 12.3434L21.168 10.3247L10.6934 0.12744L0.496205 10.568Z",
    fill: "white"
  }));
};
ArrowUpIcon.propTypes = {
  className: T.string
};
export var ArrowLeftIcon = function ArrowLeftIcon(_ref6) {
  var className = _ref6.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 22 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0777 21.6582L13.0271 19.6748L4.56996 11.3917L12.8531 2.93454L10.8343 0.98645L0.637099 11.461L11.0777 21.6582Z",
    fill: "white"
  }));
};
ArrowLeftIcon.propTypes = {
  className: T.string
};
export var UppercaseIcon = function UppercaseIcon(_ref7) {
  var className = _ref7.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 20 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.28 21.6458H4.72V11.0625H0L10 0L19.56 11.0625H15.28V21.6458Z",
    fill: "#F2F3F4"
  }));
};
UppercaseIcon.propTypes = {
  className: T.string
};
export var DeleteIcon = function DeleteIcon(_ref8) {
  var className = _ref8.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 30 22"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M28 0H7L0 10L7 20H28V0ZM12.5918 4.6L11.6 5.59177L16.0082 10C14.548 11.474 13.074 12.9479 11.6 14.4082L12.5918 15.4C14.0658 13.9397 15.5397 12.4658 17 11.0054C18.474 12.4658 19.9479 13.9397 21.4082 15.4L22.4 14.4082C20.9397 12.948 19.4658 11.474 18.0054 10C19.4658 8.53977 20.9397 7.06577 22.4 5.59177L21.4082 4.6C20.4352 5.58217 19.4561 6.55823 18.475 7.53633C17.9837 8.02611 17.4918 8.51641 17 9.00823C16.027 8.02607 15.0479 7.05002 14.0668 6.07194C13.5754 5.58214 13.0836 5.09184 12.5918 4.6Z",
    fill: "#F2F3F4",
    fillRule: "evenodd"
  }));
};
DeleteIcon.propTypes = {
  className: T.string
};
export var EmailIcon = function EmailIcon(_ref9) {
  var className = _ref9.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 20 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 0.399902V1.37448L11.2071 8.87621L22.214 1.37448V0.399902H0.200195ZM0.200195 3.27454V15.5999H22.214V3.27454L11.6495 10.4814C11.3823 10.6626 11.0322 10.6626 10.765 10.4814L0.200195 3.27454Z",
    fill: "#F2F3F4"
  }));
};
EmailIcon.propTypes = {
  className: T.string
};
export var PasswordIcon = function PasswordIcon(_ref10) {
  var className = _ref10.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.1884 14.3987L15.1959 17.2788H12.4697V14.3987C12.4697 10.8652 15.3338 8 18.8684 8C22.4018 8 25.268 10.866 25.267 14.3987V17.2788H22.5473V14.3987C22.5473 13.417 22.1647 12.4926 21.47 11.797C20.7753 11.1022 19.8509 10.7188 18.8683 10.7188C17.8848 10.7188 16.9613 11.1022 16.2666 11.797C15.571 12.4926 15.1884 13.4171 15.1884 14.3987ZM9.67041 32V19.1182H28.0667V32H9.67041ZM19.7883 28.7176V26.3082H19.7882C20.4108 25.9772 20.8364 25.3219 20.8364 24.5662C20.8364 23.4815 19.9551 22.5993 18.8685 22.5993C17.7819 22.5993 16.8997 23.4806 16.8997 24.5662C16.8997 25.3219 17.3253 25.9772 17.9488 26.3082V28.7176H19.7883Z",
    fill: "#F2F3F4",
    fillRule: "evenodd"
  }));
};
PasswordIcon.propTypes = {
  className: T.string
};

/* eslint-enable max-len */